export default __webpack_public_path__ + "static/media/Educacion-Fisica.bb4c42ca.png";